export default __webpack_public_path__ + "static/media/Banner-beneficio-mktyventas.868d8fd0.jpg";